var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-layout-content",
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: "Berita Acara Tukar Unit" } },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form",
                                _vm._b(
                                  {
                                    attrs: {
                                      layout: "vertical",
                                      form: _vm.form,
                                      labelAlign: "left"
                                    }
                                  },
                                  "a-form",
                                  _vm.formItemLayout,
                                  false
                                ),
                                [
                                  _c(
                                    "a-row",
                                    { attrs: { gutter: [16, 16] } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.customerName
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "decorator",
                                                      rawName: "v-decorator",
                                                      value:
                                                        _vm.formRules
                                                          .customerName
                                                          .decorator,
                                                      expression:
                                                        "formRules.customerName.decorator"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      _vm.formRules.customerName
                                                        .name,
                                                    placeholder: _vm.$t(
                                                      _vm.formRules.customerName
                                                        .placeholder
                                                    ),
                                                    showSearch: true,
                                                    "option-filter-prop":
                                                      "children",
                                                    "filter-option":
                                                      _vm.filterOption,
                                                    loading:
                                                      _vm.loading
                                                        .loadingCustomer,
                                                    allowClear: true
                                                  },
                                                  on: {
                                                    search: function(value) {
                                                      return _vm.getCustomerName(
                                                        value
                                                      )
                                                    },
                                                    change:
                                                      _vm.handleChangeCustomer
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.dataCustomerName,
                                                  function(data, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: data.customerId
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a-tooltip",
                                                          [
                                                            _c(
                                                              "template",
                                                              { slot: "title" },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.customerName
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  data.customerName
                                                                ) +
                                                                " "
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules
                                                    .internalContractNumber
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "decorator",
                                                      rawName: "v-decorator",
                                                      value:
                                                        _vm.formRules
                                                          .internalContractNumber
                                                          .decorator,
                                                      expression:
                                                        "\n                          formRules.internalContractNumber.decorator\n                        "
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      _vm.formRules
                                                        .internalContractNumber
                                                        .name,
                                                    placeholder: _vm.$t(
                                                      _vm.formRules
                                                        .internalContractNumber
                                                        .placeholder
                                                    ),
                                                    showSearch: true,
                                                    "option-filter-prop":
                                                      "children",
                                                    "filter-option":
                                                      _vm.filterOption,
                                                    loading:
                                                      _vm.loading
                                                        .loadingInternalContractNumber,
                                                    allowClear: true
                                                  },
                                                  on: {
                                                    search: function(value) {
                                                      return _vm.getInternalContractNumber(
                                                        value
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.dataInternalContractNumber,
                                                  function(data, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: data.icNumber
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a-tooltip",
                                                          [
                                                            _c(
                                                              "template",
                                                              { slot: "title" },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      "" +
                                                                        data.icNumber
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  "" +
                                                                    data.icNumber
                                                                ) +
                                                                " "
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.batuNumber.label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-input", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules.batuNumber
                                                        .decorator,
                                                    expression:
                                                      "formRules.batuNumber.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    _vm.formRules.batuNumber
                                                      .name,
                                                  placeholder: _vm.$t(
                                                    _vm.formRules.batuNumber
                                                      .placeholder
                                                  ),
                                                  allowClear: true
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.unitCodeOld
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-input", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules.unitCodeOld
                                                        .decorator,
                                                    expression:
                                                      "formRules.unitCodeOld.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    _vm.formRules.unitCodeOld
                                                      .name,
                                                  placeholder: _vm.$t(
                                                    _vm.formRules.unitCodeOld
                                                      .placeholder
                                                  ),
                                                  allowClear: true
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.unitCodeNew
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-input", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules.unitCodeNew
                                                        .decorator,
                                                    expression:
                                                      "formRules.unitCodeNew.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    _vm.formRules.unitCodeNew
                                                      .name,
                                                  placeholder: _vm.$t(
                                                    _vm.formRules.unitCodeNew
                                                      .placeholder
                                                  ),
                                                  allowClear: true
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.replacementDate
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-range-picker", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules
                                                        .replacementDate
                                                        .decorator,
                                                    expression:
                                                      "formRules.replacementDate.decorator"
                                                  }
                                                ],
                                                staticClass: "w-100",
                                                attrs: {
                                                  name:
                                                    _vm.formRules
                                                      .replacementDate.name,
                                                  format:
                                                    _vm.DEFAULT_DATE_FORMAT
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { attrs: { gutter: [16, 16] } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.loading.loadingFind
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onSubmit(true)
                                    }
                                  }
                                },
                                [_vm._v(" Find ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { attrs: { gutter: [16, 16] } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c("TableCustom", {
                                attrs: {
                                  dataSource: _vm.dataSource,
                                  columns: _vm.columnsTable,
                                  paginationcustom: true,
                                  defaultPagination: false,
                                  scroll: { x: "calc(950px + 50%)", y: 400 }
                                },
                                on: { "on-view": _vm.responseViewTable }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("Pagination", {
                                attrs: {
                                  total: _vm.totalData,
                                  pageSizeSet: _vm.limit,
                                  idPagination: "pagination1"
                                },
                                on: {
                                  "response-pagesize-change":
                                    _vm.responsePageSizeChange,
                                  "response-currentpage-change":
                                    _vm.responseCurrentPageChange
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 12, align: "end" } },
                            [
                              _c(
                                "a-tag",
                                {
                                  staticStyle: { "font-size": "13px" },
                                  attrs: { color: "grey" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("lbl_total_found")) +
                                      " : " +
                                      _vm._s(_vm.totalData) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }